import {
    ORDERLIST_REQUEST,
    ORDERLIST_SUCCESS,
    ORDERLIST_FAILURE,
    ORDERLIST_DELETE,
} from "../constants/ActionTypes";

const initialState = {
    loading: false,
    orderList: [],
    error: null,
};

export default function orderListReducer(state = initialState, action) {
    // 
    switch (action.type) {
        case ORDERLIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ORDERLIST_SUCCESS: 
            return {
                ...state,
                // always replacing data
                
                orderList: action.data.order_list,
                loading: false,
                // if adding data
                // data: [...state.data, action.data]
            };
        case ORDERLIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case ORDERLIST_DELETE:
                return {
                    ...state,
                    orderList: [],
                    loading: false,
                };
        default:
            return state;
    }
}
